import { createSelector } from 'reselect';
import { accountsAdapter } from './accounts';
import { RootState } from '../rootReducer';
import { AccountModel } from '@api-model/account';

const accountsState = (state: RootState) => state.accounts;

export const selectedAccStateSelector = createSelector([accountsState], (state) => {
  const { loadingPending, ...restOfState } = state ?? {};

  return {
    ...restOfState,
    loading: loadingPending > 0,
    subaccounts: accountsAdapter.getSelectors().selectAll(state.subaccounts) as AccountModel[],
  };
});

//

const userProfileState = (state: RootState) => state?.userProfile;

export const userProfileSelector = createSelector([userProfileState], (state) => ({
  ...state,
  loading: state.loadingPending > 0,
}));
